import informationIcon from '@/assets/img/annotations/information.svg'
import dangerIcon from '@/assets/img/annotations/danger.svg'
import shelterIcon from '@/assets/img/annotations/shelter.svg'
import meetingPointIcon from '@/assets/img/annotations/meeting-point.svg'
import personIcon from '@/assets/img/annotations/person.svg'

export const ANNOTATION_ICONS = [
  { value: 'information', label: 'Información', src: informationIcon },
  { value: 'danger', label: 'Peligro', src: dangerIcon },
  { value: 'shelter', label: 'Albergue', src: shelterIcon },
  { value: 'meeting-point', label: 'Punto de encuentro', src: meetingPointIcon },
  { value: 'person', label: 'Persona', src: personIcon }
]

export function getAnnotationIcon(symbol) {
  return ANNOTATION_ICONS.find(icon => icon.value === symbol) || null
}
